module.exports = __webpack_public_path__ + "img/access_pointer-2.ad9abfc8.webp";